<script setup lang="ts">
import { Popover, PopoverTrigger } from '@laam/ui/base';
import { PhCaretDown, PhCaretRight } from '@phosphor-icons/vue';

defineEmits<{
	(e: 'menu-clicked', href: string): void;
}>();

const open = ref(false);
</script>
<template>
	<Popover v-model:open="open">
		<PopoverTrigger as-child>
			<div
				class="icon-button inline-flex items-center justify-center ring-offset-white transition-colors focus-visible:outline-none focus-visible:ring-gray-400 focus-visible:ring-offset-0 focus-visible:ring-opacity-15 disabled:pointer-events-none text-gray-700 [&_svg]:fill-gray-700 hover:bg-gray-50 focus-visible:ring-0 disabled:text-gray-400 disabled:[&_svg]:fill-gray-400"
			>
				<PhCaretRight v-if="open" />
				<PhCaretDown v-else />
			</div>
		</PopoverTrigger>
		<slot />
	</Popover>
</template>
